/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedNotListedHeader_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespNotListedContent_item$ref: FragmentReference;
export type PdpRespNotListedContent_item = {|
  +saveSearchData: ?{|
    +name: ?string,
    +page: ?string,
  |},
  +$fragmentRefs: PdpSharedNotListedHeader_item$ref,
  +$refType: PdpRespNotListedContent_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespNotListedContent_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedNotListedHeader_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "saveSearchData",
      "storageKey": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "page",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bf4504a4e4445ea1a052edf8cc3e8368';
module.exports = node;
